import React, { useState } from "react";
import "./SignIn.css";
import { login } from "./webapi/AuthService";
import { Link } from "react-router-dom";
import { Translation } from "react-i18next";

import { UnauthenticatedTemplate, useMsal } from "@azure/msal-react";

const SignIn = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [entraAvailable, setEntraAvailable] = useState(true);

  const onSubmit = event => {
    event.preventDefault();
    login(email, password).then(data => {
      if (data.ID) {
        window.location.replace("/");
        setError(false);
      } else {
        setError(true);
        setPassword("");
        setErrorMessage(data);
      }
    });
  };

  const { inProgress } = useMsal();

  const isInvalid = password === "" || email === "";

  const handleEntraLogin = async () => {
    window.location.replace("/entralogin");
  };

  return (
    inProgress === "none" && (
      <Translation>
        {t => (
          <div className="container">
            <div className="row justify-content-md-center nomargin">
              <div className="col-md-5 col-lg-4">
                <div className="signinlogo">
                  <a href="">
                    <img
                      src={require("/images/zebra-img.png")}
                      className="img-fluid"
                      alt=""
                    />
                  </a>
                </div>
                {entraAvailable && (
                  <>
                    <div
                      style={{
                        position: "relative",
                        height: "55px",
                        marginLeft: "10px",
                        marginRight: "10px"
                      }}
                    >
                      <button
                        className="btn btn-outline-dark btn-block"
                        style={{ width: "100%", height: "45px" }}
                        onClick={() => handleEntraLogin()}
                      >
                        <p style={{ marginTop: "5px" }}>
                          {t("Sign in with Microsoft")}{" "}
                        </p>
                      </button>
                      <div
                        style={{
                          position: "absolute",
                          top: "10px",
                          left: "10px"
                        }}
                      >
                        <img
                          style={{ height: "25px" }}
                          src={require("/images/logos/microsoft.png")}
                        />
                      </div>
                    </div>
                    <div
                      style={{ marginLeft: "10px", marginRight: "10px" }}
                      className="hr-or"
                    >
                      {t("OR")}
                    </div>
                  </>
                )}

                <form onSubmit={onSubmit} className="signinForm">
                  <div className="form-group">
                    <input
                      className="form-control"
                      value={email}
                      onChange={event => setEmail(event.target.value)}
                      type="text"
                      placeholder={t("Email")}
                      autoFocus={true}
                    />
                  </div>
                  <div className="form-group">
                    <input
                      className="form-control"
                      value={password}
                      onChange={event => setPassword(event.target.value)}
                      type="password"
                      placeholder={t("Password")}
                    />
                  </div>
                  <button
                    className="btn btn-outline-dark btn-block"
                    disabled={isInvalid}
                    type="submit"
                  >
                    {t("Sign In")}
                  </button>
                  <Link to={"/forgotpassword"}>
                    <div className="SignInPasswordForgot">
                      {t("Forgot password?")}
                    </div>
                  </Link>
                  {error && (
                    <div className="singinerror">{t(errorMessage)}</div>
                  )}
                </form>
              </div>
            </div>
            <UnauthenticatedTemplate />
          </div>
        )}
      </Translation>
    )
  );
};

export default SignIn;
